module.exports = __webpack_public_path__ + "static/media/oberflex-aniegre-1200x2490.29413c43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-aniegre-1200x2490.jpg
// module id = 972
// module chunks = 37